import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { CustomAutocomplete } from "./CustomAutocomplete";
import { getLookup, optionLabel } from "../services/lookup";

// Searchable dropdown over another resource's rows (tm's "Search Agent",
// "Search Bank A/c", "Select Roles" ...). `value` is the selected id (or an id
// array when `multiple`); `onChange(idOrIds, row)` gets the picked row too.
const RelationInput = ({ slug, value, multiple = false, placeholder, id, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);
    getLookup(slug)
      .then((rows) => {
        if (!ignore) setOptions(rows.map((row) => ({ id: row.id, label: optionLabel(slug, row), row })));
      })
      .catch(() => {})
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [slug]);

  const ids = Array.isArray(value) ? value : [];
  const selected = multiple
    ? options.filter((option) => ids.map(Number).includes(Number(option.id)))
    : options.find((option) => String(option.id) === String(value)) || null;

  return (
    <CustomAutocomplete
      id={id}
      multiple={multiple}
      options={options}
      loading={loading}
      value={selected}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(event, picked) =>
        multiple ? onChange(picked.map((option) => option.id), picked) : onChange(picked ? picked.id : "", picked?.row)
      }
      renderInput={(params) => <TextField {...params} placeholder={selected && !multiple ? "" : placeholder} />}
    />
  );
};

export default RelationInput;
